import { CONCEPT_VALUE_ALL_OPTION } from "../constants";
import type { ConceptValue } from "../../../services/regulationsService";

export const FIELD_PLACEHOLDER_NAME = "~";
export const FIELD_PLACEHOLDER_LABEL = "Please select...";

/** Stored in RQB rule.value — mirrors Tagging Plan concept value selection. */
export type EnhancedTaggingConditionValue = {
  allValues: boolean;
  conceptValues: ConceptValue[];
};

export const createEmptyConditionValue = (): EnhancedTaggingConditionValue => ({
  allValues: false,
  conceptValues: [],
});

export function isFieldPlaceholderValue(value: string | undefined): boolean {
  return !value || value === FIELD_PLACEHOLDER_NAME;
}

export function parseEnhancedTaggingConditionValue(
  value: unknown,
): EnhancedTaggingConditionValue {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const record = value as Record<string, unknown>;
    if (typeof record.allValues === "boolean") {
      const conceptValues = Array.isArray(record.conceptValues)
        ? (record.conceptValues as ConceptValue[])
        : [];
      return {
        allValues: record.allValues,
        conceptValues: record.allValues ? [] : conceptValues,
      };
    }
  }

  if (typeof value === "string" && value.trim()) {
    if (value === CONCEPT_VALUE_ALL_OPTION.code) {
      return { allValues: true, conceptValues: [] };
    }
    return {
      allValues: false,
      conceptValues: [{ id: value, code: value, name: value }],
    };
  }

  if (Array.isArray(value)) {
    const conceptValues = value
      .map((item) => {
        if (item && typeof item === "object" && "code" in item) {
          const record = item as { code?: unknown; name?: unknown; label?: unknown; display_name?: unknown };
          const code = String(record.code ?? "").trim();
          if (!code) return null;
          const name =
            String(record.name ?? record.label ?? record.display_name ?? "").trim() ||
            code;
          return { id: code, code, name };
        }
        const code = String(item ?? "").trim();
        if (!code) return null;
        return { id: code, code, name: code };
      })
      .filter((item): item is ConceptValue => item !== null);
    if (conceptValues.length === 1 && conceptValues[0].code === "*") {
      return { allValues: true, conceptValues: [] };
    }
    if (
      conceptValues.length === 1 &&
      conceptValues[0].code === CONCEPT_VALUE_ALL_OPTION.code
    ) {
      return { allValues: true, conceptValues: [] };
    }
    return {
      allValues: false,
      conceptValues,
    };
  }

  return createEmptyConditionValue();
}
